import Actionable from "../Actionable/index.js";
import Icon from "../Icon/index.js";
import React, { forwardRef } from "react";
import { classNames } from "../../utilities/helpers.js";
import s from "./Link.module.css";
const Link = forwardRef((props, ref) => {
    const { icon, disabled, href, color = "primary", variant = "underline", className, children, attributes, type, onClick, } = props;
    const rootClassNames = classNames(s.root, className, disabled && s["--disabled"], variant && s[`--variant-${variant}`], color && s[`--color-${color}`], icon && s["--with-icon"]);
    return (React.createElement(Actionable, { href: href, disabled: disabled, className: rootClassNames, attributes: attributes, type: type, onClick: onClick, ref: ref },
        icon && React.createElement(Icon, { svg: icon }),
        children));
});
export default Link;
